import { CURRENCY, ACCOUNTING } from '../common/constants';

export default function isCurrencyStyle(style) {
    return style === CURRENCY || style === ACCOUNTING;
}


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/numbers/is-currency-style.js
// module id = 403
// module chunks = 93